import type { PplSelectOption } from '@ppl/ui/select';


export enum LANGUAGE {
  en_US = 'en_US',
  de_DE = 'de_DE',
  pt_BR = 'pt_BR',
  es_ES = 'es_ES'
}

export const LANGUAGES: PplSelectOption<LANGUAGE>[] = [
  { value: LANGUAGE.en_US, label: 'English' },
  { value: LANGUAGE.de_DE, label: 'German' },
  { value: LANGUAGE.pt_BR, label: 'Portuguese (Brazil)' },
  { value: LANGUAGE.es_ES, label: 'Spanish' },
  // { value: 'pt_PT', label: 'Portuguese (available soon)', disabled: true },
  // { value: 'fr_FR', label: 'French (available soon)', disabled: true }
];
